import {
  SITE_PREFERENCE,
  DEFAULT_SITE_DATA,
  EXPERIENCE_PRODUCT,
  VOUCHER_PRODUCT,
  MERCHANDISE_PRODUCT,
  PERKS_PRODUCT,
} from "../constants/XoxoCodeCampaignConstants";

const initialState = {
  moduleLoader: true,
  updatedPreference: SITE_PREFERENCE,
  defaultPreference: DEFAULT_SITE_DATA,
  expCityList: {},
  expProdList: EXPERIENCE_PRODUCT,
  voucherProdList: VOUCHER_PRODUCT,
  merchandiseProdList: MERCHANDISE_PRODUCT,
  perksProdList: PERKS_PRODUCT,
  voucherSites: [],
  isNullCategories: false,
  isNullMerchandiseCategories: false,
};

const xoxoCodeCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_LOADER":
      return {
        ...state,
        moduleLoader: action.payload,
      };

    case "RESTORE_REDUX_STATE":
      return {
        ...initialState,
      };

    case "UPDATE_DEFAULT_PREFERENCE":
      return {
        ...state,
        defaultPreference: action.payload,
      };

    case "UPDATE_SELECTED_SITE_PREFERENCE":
      return {
        ...state,
        updatedPreference: action.payload,
      };

    case "UPDATE_EXPERIENCE_CITY":
      return {
        ...state,
        expCityList: action.payload.expCityList,
        citiesTotal: action.payload.citiesTotal,
      };

    case "UPDATE_EXP_PROD_LOADER":
      return {
        ...state,
        expProdList: {
          ...state.expProdList,
          expProdLoader: action.payload,
        },
      };

    case "UPDATE_EXP_PROD":
      return {
        ...state,
        expProdList: action.payload,
      };

    case "UPDATE_VOUCHER_PROD_LOADER":
      return {
        ...state,
        voucherProdList: {
          ...state.voucherProdList,
          voucherProdLoader: action.payload,
        },
      };

    case "UPDATE_VOUCHER_PROD":
      return {
        ...state,
        voucherProdList: action.payload,
      };

    case "UPDATE_MERCHANDISE_PROD_LOADER":
      return {
        ...state,
        merchandiseProdList: {
          ...state.merchandiseProdList,
          merchandiseProdLoader: action.payload,
        },
      };

    case "UPDATE_MERCHANDISE_PROD":
      return {
        ...state,
        merchandiseProdList: action.payload,
      };

    case "UPDATE_PERKS_PROD_LOADER":
      return {
        ...state,
        perksProdList: {
          ...state.perksProdList,
          perksProdLoader: action.payload,
        },
      };

    case "UPDATE_PERKS_PROD":
      return {
        ...state,
        perksProdList: action.payload,
      };

    case "UPDATE_VOUCHER_SITES":
      return {
        ...state,
        voucherSites: action.payload,
      };
    case "UPDATE_VOUCHER_CATEGORIES":
      return {
        ...state,
        isNullCategories: false,
        defaultPreference: {
          ...state.defaultPreference,
          voucherCategories: action.payload,
        },
      };
    case "SET_NULL_CATEGORIES":
      return {
        ...state,
        isNullCategories: true,
      };

    case "UPDATE_MERCHANDISE_SITES":
      return {
        ...state,
        merchandiseSites: action.payload,
      };
    case "UPDATE_MERCHANDISE_CATEGORIES":
      return {
        ...state,
        isNullMerchandiseCategories: false,
        defaultPreference: {
          ...state.defaultPreference,
          merchandiseCategories: action.payload,
        },
      };
    case "SET_NULL_MERCHANDISE_CATEGORIES":
      return {
        ...state,
        isNullMerchandiseCategories: true,
      };
    default:
      return state;
  }
};

export default xoxoCodeCampaignReducer;
